<div class="notification-panel-content" data-test-id="notification-panel">
  @if (hasItems()) {
    <ng-content></ng-content>
  } @else {
    <app-empty-state
      description="No notifications to display"
      title="No Notifications"
      data-test-id="empty-state"
    ></app-empty-state>
  }
</div>

@if (hasItems()) {
  <div class="notification-panel-footer">
    <button class="clear-all-button" data-test-id="clear-all-button" (click)="clearAll.emit()">Clear all</button>
  </div>
}
